import * as React from 'react';

import { ApiKeyContext } from 'contexts/ApiKeyContext';

export const useRelativeUrl = (url: string) => {
  const { apiKey, useApiKeyInPaths } = React.useContext(ApiKeyContext);

  return useApiKeyInPaths ? `/${apiKey}${url}` : url;
};
